import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import preview from './preview/builder_component_general/builder_component_general.png';
import thumbnail from './preview/builder_component_general/builder_component_general_thumbnail.png';

CustomViewPages.register({
  id: 'builder_component_general',
  meta: {
    label: 'Component General Information',
    category: CustomViewPageCategory.BUILDER,
    typeId: {
      type: CustomViewTypeIdType.COMPONENT_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.COMPONENT_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  data: (
    <CustomViewComponent type="catalog_system_card">
      <CustomViewComponent type="container">
        {/* Common fields - always shown */}
        <CustomViewComponent type="string" label="URN" path="urn" colSpan="2" />
        <CustomViewComponent
          type="string"
          label="Description"
          path="entity.metadata.description"
          default="No description"
          colSpan="2"
        />

        {/* Non-Practice Shaper fields */}
        <CustomViewComponent
          type="link"
          label="Owner"
          path="_relations.ownedByRelations"
          showWhen={{
            value: '{{ isPracticeShaperEntity }}',
            notEquals: 'true',
          }}
          showWhenExists="_relations.ownedByRelations.length"
          kind="group"
          colSpan="2"
        />
        <CustomViewComponent
          type="string"
          label="Lifecycle"
          path="entity.spec.lifecycle"
          showWhen={{
            value: '{{ isPracticeShaperEntity }}',
            notEquals: 'true',
          }}
          showWhenHasValue
          colSpan="2"
        />
        <CustomViewComponent
          type="string"
          label="Type"
          path="entity.spec.type"
          colSpan="2"
          showWhen={{
            value: '{{ isPracticeShaperEntity }}',
            notEquals: 'true',
          }}
          showWhenExists="entity.spec.type"
        />

        {/* System fields */}
        <CustomViewComponent
          type="link"
          label="Domain"
          path="_relations.partOfDomainRelations"
          kind="domain"
          colSpan="2"
          showWhen={{
            value: '{{ _types.isSystem }}',
            equals: 'true',
          }}
        />

        {/* Component/API/Resource fields */}
        <CustomViewComponent
          type="link"
          label="System"
          path="_relations.partOfSystemRelations"
          kind="system"
          colSpan="2"
          default="No System"
          showWhen={{
            value:
              '{{ _types.isAPI or _types.isComponent or _types.isResource }}',
            equals: 'true',
          }}
        />

        {/* Component fields */}
        <CustomViewComponent
          type="link"
          label="Parent Component"
          path="_relations.partOfComponentRelations"
          kind="domain"
          colSpan="2"
          default="No Parent Component"
          showWhen={{
            value: '{{ _types.isComponent }}',
            equals: 'true',
          }}
        />

        {/* Location fields - check both isLocation AND targets.length > 0 */}
        <CustomViewComponent
          type="link_grid_list"
          label="Targets"
          path="targets"
          showWhen={{
            value: '{{ _types.isLocation and targets.length > 0 }}',
            equals: 'true',
          }}
        />

        {/* Practice Shaper automatic fields - requires BOTH isPracticeShaperEntity AND entity.spec */}
        <CustomViewComponent
          type="automatic_fields_list"
          path="entity.spec"
          exclude={['belongsTo', 'partOfDomain', 'partOfSystem']}
          defaults={{ _default: { colSpan: '2' } }}
          showWhen={{
            value: '{{ isPracticeShaperEntity and entity.spec is defined }}',
            equals: 'true',
          }}
        />

        {/* ComponentType specific fields - requires isPracticeShaperEntity AND kind === ComponentType */}
        <CustomViewComponent
          type="link"
          label="Part of system"
          path="entity.spec.partOfSystem"
          colSpan="2"
          showWhen={{
            value:
              '{{ isPracticeShaperEntity and entity.kind == ComponentType }}',
            equals: 'true',
          }}
          showWhenExists="entity.spec.partOfSystem"
        />

        {/* SystemType specific fields - requires isPracticeShaperEntity AND kind === SystemType */}
        <CustomViewComponent
          type="link"
          label="part of domain"
          path="entity.spec.partOfDomain"
          colSpan="2"
          showWhen={{
            value: '{{ isPracticeShaperEntity and entity.kind == SystemType }}',
            equals: 'true',
          }}
          showWhenExists="entity.spec.partOfDomain"
        />
        <CustomViewComponent
          type="link"
          label="belongs to"
          path="entity.spec.belongsTo"
          colSpan="2"
          showWhen={{
            value: '{{ isPracticeShaperEntity and entity.kind == SystemType }}',
            equals: 'true',
          }}
          showWhenExists="entity.spec.belongsTo"
        />

        {/* Taxonomy fields */}
        <CustomViewComponent
          type="link"
          label="{{ taxonomyLabel }}"
          path="taxonomies"
          colSpan="2"
          showWhen={{
            value: '{{ _types.isSystem or _types.isHeadlessComponent }}',
            equals: 'true',
          }}
        />

        {/* Partially Deployable In - System only */}
        <CustomViewComponent
          type="string"
          label="Partially Deployable In"
          path="partiallyDeployableIn"
          showWhen={{
            value: '{{ _types.isSystem }}',
            equals: 'true',
          }}
          showWhenHasValue
          colSpan="2"
        />
        <CustomViewComponent
          type="hline"
          showWhen={{
            value: '{{ tags.length }}',
            notEquals: 0,
          }}
        />
        <CustomViewComponent
          type="tags"
          label="Tags"
          path="tags"
          showWhen={{
            value: '{{ tags.length }}',
            notEquals: 0,
          }}
        />
      </CustomViewComponent>
    </CustomViewComponent>
  ),
});
